export const FONT_TYPES = {
  TITLE: "title",
  BODY: "body"
}
